<style src="./BoardResponsibleUser.scss" lang="scss"></style>
<template>
  <section class="board-responsible-user board-module">
    <span class="moduletitle">Convidados</span>
    <modal-users
      v-model="users"
      @remove="modalRemoveUser" />

    <select
      class="cp1-small-select field"
      v-model="form.user"
      @change="selected">
      <option :value="null">Escolha um convidado</option>
      <option
        v-for="(user, userIdx) in userList"
        :key="userIdx"
        :value="user">{{ user.text }}</option>
    </select>
  </section>
</template>

<script>
import ModalUsers from '../../../modal-users/ModalUsers'

export default {
  name: 'BoardResponsibleUser',
  components: {
    ModalUsers
  },
  props: {
    value: {
      default: null
    },
    userList: {
      default: null
    }
  },
  data: () => ({
    users: null,
    form: {
      user: null
    }
  }),
  watch: {
    value: {
      handler (v) {
        this.users = v
      },
      immediate: true
    },
    users (v) {
      this.$emit('input', v)
    }
  },
  methods: {
    modalRemoveUser (v) { this.$emit('remove', v) },
    selected () { this.$emit('selected', this.form.user) }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/board/components/board-details/components/board-responsible-user/BoardResponsibleUser.vue